import { render } from "./OnboardLayout.vue?vue&type=template&id=5b526f02"
import script from "./OnboardLayout.vue?vue&type=script&lang=js"
export * from "./OnboardLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__